export default {
  error: 'Foram encontrados os seguintes problemas com os dados introduzidos. Você deve corrigi-los para que a operação possa ser realizada corretamente.'
}